module.exports = __webpack_public_path__ + "static/img/MoorePeter_BrechtGeorge_DouglassCollege_1963.9789fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/brecht/images/MoorePeter_BrechtGeorge_DouglassCollege_1963.jpg
// module id = dXd7
// module chunks = 0